export function transformTime(zone, date) {
    if(date) {
        return new Date(new Date(date).toLocaleString('zh-CN', { timeZone: zone })).getTime();
    }else {
        return new Date(new Date().toLocaleString('zh-CN', { timeZone: zone })).getTime();
    }
}

/**
 * 为接口返回的相对资源路径补上当前环境的 API 根地址。
 * 完整 URL、协议相对 URL、data URL 和 blob URL 会保持原样。
 */
export function resolveResourceUrl(url) {
    if(!url || typeof url !== 'string') {
        return url || ''
    }

    if(/^(https?:)?\/\//i.test(url) || /^(data|blob):/i.test(url)) {
        return url
    }

    const apiRoot = (process.env.VUE_APP_API_ROOT || '').replace(/\/+$/, '')
    const resourcePath = url.replace(/^\/+/, '')

    if(!apiRoot || apiRoot === '/') {
        return `/${resourcePath}`
    }

    return `${apiRoot}/${resourcePath}`
}
